export class JobStep {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "stepName",
            "baseName": "stepName",
            "type": "JobStepName",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "JobStepStatus",
            "format": ""
        },
        {
            "name": "startTime",
            "baseName": "startTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endTime",
            "baseName": "endTime",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return JobStep.attributeTypeMap;
    }
    constructor() {
    }
}
